import { px, rect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const wings: Record<string, Part> = {
  wing_swept: {
    id: 'wing_swept',
    category: 'wing',
    name: 'Swept',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 7; i++) {
        const w = 7 - i;
        const x0 = side === 'left' ? a.x - i : a.x + i + 1 - w;
        rect(ctx, x0, a.y - 1 + Math.floor(i * 0.4), w, 3 - Math.floor(i * 0.3), p.primary);
      }
      for (let i = 0; i < 7; i++) px(ctx, a.x + dir * i, a.y - 1 + Math.floor(i * 0.4), p.light);
      for (let i = 0; i < 7; i++) {
        const w = 7 - i;
        const x0 = side === 'left' ? a.x - i : a.x + i + 1 - w;
        const y0 = a.y - 1 + Math.floor(i * 0.4) + (3 - Math.floor(i * 0.3)) - 1;
        rect(ctx, x0, y0, w, 1, p.shadow);
      }
      px(ctx, a.x + dir * 6, a.y, p.accent);
    },
  },
  wing_delta: {
    id: 'wing_delta',
    category: 'wing',
    name: 'Delta',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 8; i++) {
        const w = 8 - i;
        const x0 = side === 'left' ? a.x - i - 1 : a.x + i + 2 - w;
        rect(ctx, x0, a.y + i, w, 1, p.primary);
      }
      for (let i = 0; i < 8; i++) px(ctx, a.x + dir * (i + 1), a.y + i, p.light);
      px(ctx, a.x + dir * 7, a.y, p.accent);
    },
  },
  wing_forked: {
    id: 'wing_forked',
    category: 'wing',
    name: 'Forked',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 6; i++) {
        const x = a.x + dir * (i + 1);
        rect(ctx, x, a.y - 2 + Math.floor(i * 0.3), 1, 2, p.primary);
        rect(ctx, x, a.y + 2 + Math.floor(i * 0.3), 1, 2, p.primary);
      }
      px(ctx, a.x + dir * 6, a.y - 2, p.accent); px(ctx, a.x + dir * 6, a.y + 4, p.accent);
    },
  },
  wing_stub: {
    id: 'wing_stub',
    category: 'wing',
    name: 'Stub',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      const x0 = side === 'left' ? a.x - 4 : a.x + 1;
      rect(ctx, x0, a.y, 4, 4, p.primary); rect(ctx, x0, a.y, 4, 1, p.light); rect(ctx, x0, a.y + 3, 4, 1, p.shadow);
      px(ctx, a.x + dir * 4, a.y + 1, p.accent); px(ctx, a.x + dir * 4, a.y + 2, p.accent);
    },
  },
  wing_long: {
    id: 'wing_long',
    category: 'wing',
    name: 'Long',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 10; i++) {
        const x0 = side === 'left' ? a.x - i - 1 : a.x + i + 1;
        rect(ctx, x0, a.y, 1, 2, p.primary);
        px(ctx, x0, a.y, p.light); px(ctx, x0, a.y + 1, p.shadow);
      }
      px(ctx, a.x + dir * 10, a.y, p.accent);
    },
  },
  wing_gull: {
    id: 'wing_gull',
    category: 'wing',
    name: 'Gull',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 4; i++) {
        const x = a.x + dir * (i + 1); const y = a.y - i;
        rect(ctx, x, y, 1, 2, p.primary); px(ctx, x, y, p.light);
      }
      for (let i = 4; i < 8; i++) {
        const x = a.x + dir * (i + 1); const y = a.y - 4 + (i - 4);
        rect(ctx, x, y, 1, 2, p.primary); px(ctx, x, y, p.light);
      }
      px(ctx, a.x + dir * 8, a.y, p.accent);
    },
  },
  wing_spike: {
    id: 'wing_spike',
    category: 'wing',
    name: 'Spike',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 9; i++) {
        const x = a.x + dir * (i + 1);
        rect(ctx, x, a.y, 1, 1, p.primary);
        if (i < 6) px(ctx, x, a.y + 1, p.shadow);
      }
      px(ctx, a.x + dir * 9, a.y, p.accent); px(ctx, a.x + dir * 8, a.y - 1, p.metalDark);
    },
  },
  wing_bowed: {
    id: 'wing_bowed',
    category: 'wing',
    name: 'Bowed',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      const bow = [0, -1, -2, -2, -2, -1, 0, 1];
      for (let i = 0; i < 8; i++) {
        const x = a.x + dir * (i + 1);
        const yb = a.y + bow[i];
        rect(ctx, x, yb, 1, 3, p.primary);
        px(ctx, x, yb, p.light);
        px(ctx, x, yb + 2, p.shadow);
      }
      px(ctx, a.x + dir * 4, a.y - 2, p.accent);
    },
  },
  wing_canard: {
    id: 'wing_canard',
    category: 'wing',
    name: 'Canard',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -5, offsetY: -4 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  5, offsetY: -4 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      for (let i = 0; i < 6; i++) {
        const x = a.x + dir * (i + 1);
        const y = a.y - Math.floor(i * 0.9);
        rect(ctx, x, y, 1, 2, p.primary);
        px(ctx, x, y, p.light);
        px(ctx, x, y + 1, p.shadow);
      }
      px(ctx, a.x + dir * 6, a.y - 5, p.accent);
    },
  },
  wing_broad: {
    id: 'wing_broad',
    category: 'wing',
    name: 'Broad',
    requires: 'wing_pair',
    provides: {
      [SLOT.WINGTIP_L]: { baseSlot: SLOT.WING_L, offsetX: -6, offsetY: 1 },
      [SLOT.WINGTIP_R]: { baseSlot: SLOT.WING_R, offsetX:  6, offsetY: 1 },
    },
    draw: (ctx, a, p, side) => {
      const dir = side === 'left' ? -1 : 1;
      const x0 = side === 'left' ? a.x - 6 : a.x + 1;
      rect(ctx, x0, a.y - 1, 6, 5, p.primary);
      rect(ctx, x0, a.y - 1, 6, 1, p.light);
      rect(ctx, x0, a.y + 3, 6, 1, p.shadow);
      const xe = side === 'left' ? x0 : x0 + 5;
      rect(ctx, xe, a.y - 1, 1, 5, p.shadow);
      px(ctx, a.x + dir * 6, a.y + 1, p.accent);
    },
  },
};
